__turbopack_context__.v({
  "down": "mm1VXq_down",
  "fillTable": "mm1VXq_fillTable",
  "historyTable": "mm1VXq_historyTable",
  "labelCell": "mm1VXq_labelCell",
  "missing": "mm1VXq_missing",
  "schemaPicker": "mm1VXq_schemaPicker",
  "statisticsPage": "mm1VXq_statisticsPage",
  "steady": "mm1VXq_steady",
  "tableWrapper": "mm1VXq_tableWrapper",
  "tabs": "mm1VXq_tabs",
  "totalCell": "mm1VXq_totalCell",
  "up": "mm1VXq_up",
  "versionDate": "mm1VXq_versionDate",
  "versionTime": "mm1VXq_versionTime",
});
